module.exports = __webpack_public_path__ + "img/heart.5b68ed2d.svg";